export default "__VITE_ASSET__DerbK$$P__"